<template lang="pug">
  b-container(fluid)
    b-card(v-if="$can('read', 'set-reactivation-time')")
      h4 Reactivación automática del Bot (minutos)
      p.text-secondary Cuando una persona contesta una conversación desde Casos o Chats, el Chatbot se desactivará automáticamente para no intervenir en la conversación. Si deseas que se reactive después de cierto tiempo, introduce la cantidad de minutos que necesites. En Cero solo se puede reactivar manualmente.
      .d-flex.align-items-center.mb-1
        number-input.mr-3(v-model="auto_reactivation_time", controls, inline, center, placeholder="0", :min="0")
        b-button(variant="primary", size="sm", v-if="auto_reactivation_time_changed", @click="updateAccountReactivationTime", :disabled="saving_reactivation_time")
          span Guardar
          b-spinner.ml-2(small, type="grow", variant="light", v-if="saving_reactivation_time")
      span.text-danger.text-sm(v-if="auto_reactivation_time == 0") No se reactiva automáticamente
    hr
    h4.mt-4.mb-0 Conectar plataforma
    b-link.text-primary.mb-4.text-sm.d-block(:to="{name: 'Términos Condiciones'}" target="_blank") Términos y condiciones
    b-row.mb-4
      b-col(md="6")
        b-input-group
          b-form-input(placeholder="Buscar plataforma", v-model="search_platform", type="search", trim)
          b-input-group-append
            b-input-group-text
              search-icon.text-secondary.icon-sm
    p(v-if="!availablePlatforms.length").text-secondary {{ search_platform ? 'No se encontraron coincidencias' : 'No hay plataformas disponibles' }}
    .platforms-container-row
      .platform-square.pointer.bg-light.mr-3.d-inline-block(v-for="platform in availablePlatforms", :key="platform.name", @click="beforeAuthenticate(platform)", style="border-radius:5px;")
        .d-flex.align-items-center.justify-content-center.p-3.flex-column
          v-icon.mb-3(:name="platform.description", scale="2")
          //p.mb-0.text-help.text-sm Conectar
          p.mb-0 {{ platform.title }}
    h4.my-4 Plataformas conectadas
    p(v-if="!filteredPlatforms.filter(p => !p.error).length || (!filteredPlatforms.filter(p => !p.error).length && search_platform)").text-secondary {{ search_platform ? 'No se encontraron coincidencias' : 'No has conectado plataformas' }}
    b-row
      //- b-col(cols="12", md="6", xl="4")
      //-   b-input-group.mb-3
      //-     b-form-input(placeholder="Buscar plataforma", v-model="search_platform", type="search", trim)
      //-     b-input-group-append
      //-       b-input-group-text
      //-         search-icon.text-secondary.icon-sm
      //-   b-card.no-shadow.bg-light.text-center
      //-     div(v-if="availablePlatforms.length")
      //-       p Selecciona la plataforma que deseas conectar:
      //-       b-list-group.list-group-flush.mb-0
      //-         b-list-group-item.d-flex.justify-content-between.align-items-center.show-on-hover-container.pointer.hover-primary(v-for="platform in availablePlatforms", :key="platform.name", @click="beforeAuthenticate(platform)")
      //-           div.text-truncate
      //-             v-icon.mr-2(:name="platform.description")
      //-             span {{ platform.title }}
      //-           arrow-right-circle-icon.icon-sm.text-primary.show-on-hover(v-if="platform.error")
      //-           check-circle-icon.icon-sm.text-success(v-else-if="platform.accounts.length")
      //-     div(v-else-if="filteredPlatforms.filter(p => !p.error).length")
      //-       p.mb-0 {{ filteredPlatforms.filter(p => !p.error).length }} cuentas conectadas
      //-     div(v-else)
      //-       p.mb-0(v-if="search_platform") Sin coincidencias
      //-       p.mb-0(v-else) No hay plataformas disponibles
      //-     b-alert.text-sm.mb-0.text-left.mt-3(:show="isKonverza", variant="info")
      //-       b-link.text-reset(v-b-toggle.whatsapp-info) Conectar a Whatsapp
      //-       b-collapse.mt-2(id="whatsapp-info")
      //-         span.mr-1 Para solicitar una cotización de la plataforma Whatsapp, envía un correo a
      //-         a(:href="`mailto:soporte%40konverza.me?subject=Cotizaci%C3%B3n%20Konverza%20Whatsapp%20Cuenta%20${$route.params.account_id}`") soporte@konverza.me
      b-col(cols="12", v-for="platform in filteredPlatforms.filter(p => !p.error)", :key="platform.name" v-if="accountsLoaded")
        connect-platform(v-bind="platform", @refresh="refreshPlatformData(platform)", @connect="beforeAuthenticate(platform)", @authenticate="beforeAuthenticate(platform, 'change')", @responding_mode="updatePlatformConfiguration(platform, 'responding_mode', $event)", @enabled="updatePlatformConfiguration(platform, 'enabled', $event)", @toggle_config="configPlatform", @reconnect="reconnectAccount", @desconnect="confirmDesconnect")
      b-modal(scrollable, title="Conectar página", v-model="select_page_modal", ok-only, ok-title="Cancelar", ok-variant="secondary")
        p Selecciona la página donde contestará el bot:
        b-input-group.mb-3
          b-form-input(placeholder="Buscar página", v-model="search_facebook_page", type="search", trim)
          b-input-group-append
            b-input-group-text
              search-icon.text-secondary.icon-sm
        b-table(hover, borderless, :fields="facebook_pages_fields", :items="facebook_pages", :filter="search_facebook_page", show-empty)
          template(v-slot:empty)
            p.mb-0 No hay páginas disponibles
            p.mb-0.text-sm.text-help Si no aparece tu página, probablemente no tengas permisos suficientes para conectarla
          template(v-slot:emptyfiltered)
            p.mb-0 Sin coincidencias
          template(v-slot:cell(name)="{ item }")
            b-row.align-items-center
              b-col.d-flex.align-items-center
                b-img.mr-2(width="40", height="40", :src="item.picture.data.url", @error="item.error = true", v-if="!item.error", rounded="circle")
                span.text-break {{ item.name }}
              b-col.mt-md-0.mt-2.text-right(md="auto")
                b-button(size="sm", :variant="item.isConnected ? 'light' : 'success'", @click="confirmConnect(item)", :disabled="item.isConnected") {{ item.isConnected ? 'Ya conectada' : 'Conectar página' }}
            b-row.align-items-center.text-right.text-md-left.mt-1(v-if="item.isConnected && item.other_accounts.length")
              b-col
                .text-sm.text-secondary Esta página ya ha sido conectada en otra cuenta
              b-col(md="auto")
                b-dropdown.mr-2(variant="link", size="sm", right, no-caret, :menu-class="['filters-dropdown']")
                  template(slot="button-content")
                    b-link.text-sm Desconectar
                  b-dropdown-header Desconectar cuenta de esta página
                  b-dropdown-item(v-for="account in item.other_accounts", :key="account.account_id", @click="confirmDesconnect(account, true)") {{account.name}}
      b-modal(hide-footer, size="lg", title="Configuración Messenger", v-model="msn_config_modal")
        messenger-config(v-if="msn_config_modal", v-bind="platform_account")
      b-modal(hide-footer, size="lg", title="Configuración Widget Web", v-model="bm_config_modal")
        bmessaging-config(v-if="bm_config_modal", v-bind="platform_account", @updatename="platform_account.name = $event")
      b-modal(hide-footer, size="lg", title="Configuración Voicebot", v-model="voicebot_config_modal")
        voicebot-config(v-bind="platform_account")
      b-modal(hide-footer, size="lg", title="Configuración Alexa", v-model="alexa_config_modal")
        alexa-config(v-bind="platform_account")
      b-modal(hide-footer, size="lg", title="Configuración Whatsapp", v-model="whatsapp_official_config_modal")
        whatsapp-config(v-bind="platform_account")
      b-modal(title="Whatsapp Gupshup", v-model="gupshupModal", ok-title="Conectar cuenta", cancel-title="Cancelar", ok-variant="primary", :ok-disabled="!gupshupAccountComplete", @ok="confirmCreateGupshup")
        b-container
          b-row
            b-col(cols="12")
              b-form-group(label="Nombre de tu aplicación en Gupshup")
                b-form-input(placeholder="Nombre de tu aplicación en Gupshup", v-model="gupshup_account.name")

              b-form-group(label="Número de teléfono aprobado", description="Debe ser un número aprobado por Whatsapp a través de tu dashboard de Gupshup.")
                b-form-input(placeholder="Whatsapp aprobado", v-model="gupshup_account.phone_number")

              b-form-group(label="API KEY", description="Esta API KEY la encuentras en tu cuenta de GupShup")
                b-form-input(placeholder="API KEY", v-model="gupshup_account.api_key")

              //- b-form-group(label="Guardar stickers", description="No lo actives si NO lo necesitas o no sabes para qué es esta función.")
              //-   p.mb-2.text-secondary Si deseas guardar los stickers que se intercambien en la conversación, marca esta casilla.
              //-   b-alert.text-sm(show, variant="success") Actives o no esta función tu Chatbot podrá recibir stickers.
              //-   b-form-checkbox(v-model="gupshup_account.save_stickers") Guardar stickers
</template>

<script>
import { mapActions, createNamespacedHelpers} from 'vuex'
import ConnectPlatform from '../../components/ConnectPlatform.vue'
import MessengerConfig from '../../components/MessengerConfig'
import BmessagingConfig from '../../components/BmessagingConfig'
import VoicebotConfig from "../../components/VoicebotConfig";
import AlexaConfig from "../../components/AlexaConfig";
import WhatsappConfig from "../../components/WhatsappConfig";
import subscriptionSchema from '@/helpers/subscription-schema'
import authenticateHelper from '@/helpers/authenticate-helper'

const accountController = createNamespacedHelpers('account')
const facebookController = createNamespacedHelpers('facebook')
const partnerController = createNamespacedHelpers('partner')
const _ = require('lodash')

export default {
  mixins: [authenticateHelper],
  data () {
    return {
      auto_reactivation_time: 0,
      auto_reactivation_time_changed: false,
      saving_reactivation_time: false,
      search_platform: '',
      default_platforms: ['sandbox'],
      platforms: [],
      select_page_modal: false,
      facebook_pages_fields: [
        {
          key: 'name',
          label: 'Nombre de página'
        }
      ],
      search_facebook_page: '',
      auth_platform: '',
      msn_config_modal: false,
      bm_config_modal: false,
      voicebot_config_modal: false,
      alexa_config_modal: false,
      whatsapp_official_config_modal: false,
      platform_account: null,
      gupshup_account: {
        name: '',
        phone_number: '',
        api_key: '',
        save_stickers: false
      },
      gupshupModal: false,
      whatsapp_numbers: [],
      accountsLoaded: false
    }
  },
  computed: {
    ...facebookController.mapState({
      facebook_pages: state => state.pages
    }),
    ...accountController.mapState({
      account: state => state.account
    }),
    ...partnerController.mapState({
      partner: state => state.partner
    }),
    filteredPlatforms () {
      const platforms = this.platforms.filter(p => {
        if (!this.search_platform) return true
        return p.name.search(new RegExp(this.search_platform, 'gmi')) >= 0 || p.title.search(new RegExp(this.search_platform, 'gmi')) >= 0
      })
      return platforms.map(p=>{
        const names = ['whatsapp_official','Whatsapp Official']
        if(names.includes(p.name)){
          p.accounts.forEach(wa=>{
          const phone_status=this.get_whatsapp_phone_status(wa.phone_number)
          if(phone_status) wa.phone_status=phone_status
          })
          }
        return p
      })
    },
    availablePlatforms () {
      return this.filteredPlatforms.filter(p => !this.default_platforms.includes(p.name))
    },
    isKonverza () {
      return (new RegExp('^konverza-', 'i')).test(this.getCurrentUser().role_type)
    },
    gupshupAccountComplete () {
      return this.gupshup_account.name && this.gupshup_account.phone_number && this.gupshup_account.api_key
    }
  },
  methods: {
    ...mapActions(['flow/all', 'partner/get', 'flow/get', 'account/get', 'account/update', 'platform/all', 'platform/get', 'auth/authenticate', 'facebook/pages', 'account/updateAccessToken', 'account/updatePlatformSubscription', 'account/updatePlatformConfiguration', 'account/desconnectPlatform','account/phones_status','account/phone_stats']),
    getAccount () {
     let self = this

     this['account/get']({
       account_id: self.$route.params.account_id,
       callback: res => {
         if (res.error) {
           self.$message.error(res.error)
         } else {
           // self.account_name = res.name || '';
           self.auto_reactivation_time = res.resource.auto_reactivation_time || 0
           self.$nextTick(() => {
             self.auto_reactivation_time_changed = false
           })
         }
       }
     })
    },
    updateAccountReactivationTime () {
      var self = this

      this.saving_reactivation_time = true
      this['account/update']({
        account_id: self.$route.params.account_id,
        auto_reactivation_time: self.auto_reactivation_time,
        callback: res => {
          self.saving_reactivation_time = false

          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Tiempo de reactivación automática actualizado')
            self.auto_reactivation_time_changed = false
          }
        }
      })
    },
    getPlatforms () {
      let self = this
      this.showLoadingScreen()

      this['platform/all']({
        account_id: self.$route.params.account_id,
        callback: async (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let temp_platforms = res.resource.map(p => {
              p.loading = false
              p.error = false
              p.accounts = []
              return p
            })

            for (let platform of temp_platforms) {
              let platformAccount = await self.getPlatformData(platform)
              if (platformAccount) {
                platform.accounts = platformAccount.filter(p => Boolean(p.external_id) && Boolean(p.model_id) && Boolean(p.platform))
              } else {
                platform.error = true
              }
            }

            temp_platforms.sort((a,b) => a.name > b.name ? 1 : -1)
            self.platforms = temp_platforms.slice()
            self.hideLoadingScreen()
            self.get_whatsapp_numbers()
          }
        }
      })
    },
    getPlatformData (platform) {
      let self = this

      return new Promise(resolve => {
        self['platform/get']({
          account_id: self.$route.params.account_id,
          platform_id: platform.platform_id,
          callback: res => {
            if (res.error) {
              resolve(null)
            } else {
              resolve(Array.isArray(res.resource) && res.resource.length ? res.resource : null)
            }
          }
        })
      })
    },
    async refreshPlatformData (platform) {
      console.log(platform);
      let platformAccount = await this.getPlatformData(platform)
      console.log(platformAccount);
      if (platformAccount) {
        platform.accounts = platformAccount
        platform.error = false
      } else {
        platform.error = true
      }

      let index = this.platforms.findIndex(p => p.name == platform.name)
      if (index >= 0) {
        console.log(platform)
        this.platforms.splice(index, 1, platform)
      }
    },
    beforeAuthenticate (platform, isChange = false) {
      //if (this.preventConnect()) return

      if (platform.accounts.length && this.isKonverza && !isChange) {
        this.$bvModal.msgBoxOk('Sólo puedes conectar una cuenta por plataforma. Da click en "Cambiar cuenta", bajo el nombre de la cuenta conectada, para cambiarla.', {
          title: 'Cuenta conectada',
          okVariant: 'light',
          okTitle: 'Cerrar',
          centered: true
        })
        .then(value => {

        })
        .catch(err => {
          // An error occurred
        })

        return
      }

      const h = this.$createElement

      if(platform.name === 'bmessaging') {
        this.confirmConnectBmessaging()
        return
      }

      if (platform.name === 'instagram') {
        this.$bvModal.msgBoxConfirm([
          h('p', { class: ['bm-3'] }, 'Antes de continuar, asegúrate de tener una cuenta de Instagram para negocios vinculada a una página de Facebook. '),
          h('p', { class: ['mb-2'] }, [
            h('b-link', { class:['text-primary', 'text-sm'], props:{ href: 'https://help.instagram.com/502981923235522', target: 'blank' } }, 'Más información sobre Instagram para negocios.')
          ]),
          h('p', { class: ['mb-0'] }, [
            h('b-link', { class:['text-primary', 'text-sm'], props:{ href: 'https://www.facebook.com/help/instagram/790156881117411', target: 'blank' } }, '¿Cómo vincular una página de Facebook a mi Instagram para negocios.')
          ])
        ], {
          title: 'Conectar página',
          okVariant: 'primary',
          okTitle: 'Continuar',
          cancelTitle: 'Cancelar'
        })
        .then(value => {
          if (value) {
            this.authenticate(platform)
          }
        })
        .catch(() => {
          this.$message.warning('No se conectó la cuenta.', 'warning')
        })
      } else if (platform.name === 'instagram_dm') {
        this.$bvModal.msgBoxConfirm([
          h('p', { class: ['bm-3'] }, 'Antes de continuar, asegúrate de tener una cuenta de Instagram profesional vinculada a una página de Facebook e ingresar con una cuenta de Facebook Developer con un nivel de acceso "MODERADO"'),
          h('p', { class: ['mb-2'] }, [
            h('b-link', { class:['text-primary', 'text-sm'], props:{ href: 'https://www.facebook.com/help/instagram/138925576505882', target: 'blank' } }, 'Más información sobre cuentas de Instagram profesionales.')
          ]),
          h('p', { class: ['mb-0'] }, [
            h('b-link', { class:['text-primary', 'text-sm'], props:{ href: 'https://www.facebook.com/help/instagram/790156881117411', target: 'blank' } }, '¿Cómo vincular una página de Facebook a mi Instagram para negocios.')
          ])
        ], {
          title: 'Conectar página',
          okVariant: 'primary',
          okTitle: 'Continuar',
          cancelTitle: 'Cancelar'
        })
            .then(value => {
              if (value) {
                this.authenticate(platform)
              }
            })
            .catch(() => {
              this.$message.warning('No se conectó la cuenta.', 'warning')
            })
      } else {
        this.authenticate(platform)
      }
    },
    authenticate (platform) {
      let self = this

      if (!this.canAuthenticate(platform)) {
        this.$message.warning('Para conectar esta cuenta contacta a tu Agencia o Bot Trainer.')
        return
      }

      if (platform.name === 'whatsapp_gupshup') {
        this.gupshupModal = true;
        this.auth_platform = 'whatsapp_gupshup';
      } else if (platform.name === 'whatsapp_official') {
        this.launchWhatsAppSignup()
      } else {
        this['auth/authenticate']({
          provider: platform.name || platform,
          payload: {
            account_id: this.$route.params.account_id
          },
          callback: res => {
            console.log(res)
            if (res.success) {
              self.parseAuthenticationResponse(res)
            } else {
              this.$message.error(res.error)
            }
          }
        })
      }
    },
    parseAuthenticationResponse (res) {
      this.auth_platform = res.platform
      switch (res.platform) {
        case 'facebook':
        case 'messenger':
        case 'instagram':
        case 'instagram_dm':
          this.getFacebookPages(res.data.access_token, res.platform)
          break
        case 'twitter':
        case 'twitterDM':
          this.confirmConnect(res.data)
          break
        case 'h4mail':
          if(res.success) {
            let platform = this.platforms.find(p => p.name == res.platform)
            this.refreshPlatformData(platform)
            this.$message.success('Cuenta conectada.')
          } else {
            this.$message.warning('Por favor ponte en contacto con soporte')
          }
          break
        default:
          this.$message.warning('Por favor ponte en contacto con soporte')
      }
    },
    getFacebookPages (access_token, platform) {
      let self = this
      this.showLoadingScreen()

      this['facebook/pages']({
        platform: platform,
        account_id: self.$route.params.account_id,
        params: {
          access_token: access_token,
          fields: 'access_token,name,id,tasks,instagram_business_account,pages_read_engagement,picture{url}',
          limit: 200
        },
        callback: res => {
          self.hideLoadingScreen()
          if(this.platform_account) {
            this.findPlatformAccount()
          } else {
            self.select_page_modal = true
            console.log("FACEBOOK_PAGES", this.facebook_pages)
          }
        }
      })
    },
    confirmConnect (account) {
      /*if (account.isConnected) {
        this.$message.warning('Esta página ya ha sido conectada en ésta u otra cuenta.')
        this.platform_account = null
        return
      }*/
      account.platform = this.auth_platform
      let subscription = subscriptionSchema(account)

      this.$bvModal.msgBoxConfirm(`Se conectará el bot a la cuenta ${subscription.name}. ¿Deseas continuar?`, {
        title: 'Conectar página',
        okVariant: 'success',
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar',
      })
      .then(value => {
        if (value == true) {
          this.updatePlatformSubscription(subscription)
          //this.platform_account ? this.updatePlatformAccount() : this.updatePlatformSubscription(subscription)
        } else {
          this.platform_account = null
        }
      })
      .catch(err => {
        this.$message.warning('No se conectó la cuenta.', 'warning')
        this.platform_account = null
      })
    },
    confirmConnectBmessaging () {
      this.$bvModal.msgBoxConfirm(`Se conectará el bot a Widget Web. ¿Deseas continuar?`, {
        title: 'Conectar',
        okVariant: 'success',
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar',
      })
      .then(value => {
        if (value == true) {
          const subscription = {
            platform: 'bmessaging',
            name: this.account.name
          }
          this.updatePlatformSubscription(subscription)
        } else {
          this.platform_account = null
        }
      })
      .catch(err => {
        this.$message.warning('No se conectó la cuenta.', 'warning')
        this.platform_account = null
      })
    },
    confirmCreateGupshup () {
      this.$bvModal.msgBoxConfirm(`Se conectará el bot a la cuenta ${this.gupshup_account.name} con el teléfono ${this.gupshup_account.phone_number}. Al dar Confirmar aceptas que este número ha sido aprobado por Whatsapp y todos los datos son correctos. ¿Deseas continuar?`, {
        title: 'Conectar Gupshup',
        okVariant: 'success',
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar',
      })
      .then(value => {
        if (value == true) {
          this.confirmConnect(this.gupshup_account)
        }
      })
      .catch(err => {
        this.$message.warning('No se conectó la cuenta.', 'warning')
      })
    },
    updatePlatformSubscription (subscription) {
      let self = this
      this.showLoadingScreen()

      let platform = this.platforms.find(platform => {
        return platform.name == subscription.platform
      })

      this['account/updatePlatformSubscription']({
        account_id: self.$route.params.account_id,
        platform_id: platform.platform_id,
        ...subscription,
        konverza: 1,
        callback: res => {
          self.hideLoadingScreen()
          if (res.success) {
            self.$message.success('Cuenta conectada con éxito')
            self.select_page_modal = false
            self.search_facebook_page = ''
            self.platform_account = null
            self.gupshupModal = false
            // self.clearObject(this.gupshup_account)
            self.refreshPlatformData(platform)
          } else {
            self.$message.error('Error conectando cuenta')
          }
        }
      })
    },
    updatePlatformConfiguration (platform, attribute, value) {
      let self = this
      let params = {}
      params[attribute] = value

      this['account/updatePlatformConfiguration']({
        account_id: self.$route.params.account_id,
        platform_id: platform.platform_id,
        ...params,
        callback: res => {
          if (res.success) {
            platform = Object.assign(platform, res.resource)
            self.$message.success('Plataforma actualizada')
            self.platform_account = null
            self.refreshPlatformData(platform)
          } else {
            self.$message.error(res.error)
          }
        }
      })
    },
    configPlatform (platform_account) {
      this.platform_account = platform_account
      this.msn_config_modal = platform_account.platform === 'messenger'
      this.bm_config_modal = platform_account.platform === 'bmessaging'
      this.voicebot_config_modal = platform_account.platform === 'voicebot'
      this.alexa_config_modal = platform_account.platform === 'alexa'
      this.whatsapp_official_config_modal = platform_account.platform === 'whatsapp_official'
    },
    reconnectAccount (platform_account) {
      if (this.preventConnect()) return
      this.platform_account = platform_account
      this.authenticate(platform_account.platform)
    },
    confirmDesconnect (platform_account, other = false) {
      this.platform_account = platform_account
      this.$bvModal.msgBoxConfirm(`Se desconectará la cuenta. ¿Deseas continuar?`, {
        title: 'Desconecctar cuenta ' + platform_account.name,
        okVariant: 'danger',
        okTitle: 'Desconecctar',
        cancelTitle: 'Cancelar',
      })
      .then(value => {
        if (value == true) {
          other ? this.desconnectOtherAccount() : this.desconnectAccount()
        } else {
          this.platform_account = null
        }
      })
      .catch(err => {
        this.$message.warning('Error al eliminar la cuenta.', 'warning')
      })
    },
    desconnectAccount () {
      let self = this
      this.showLoadingScreen()

      let platform = this.platforms.find(platform => platform.name == self.platform_account.platform)

      this['account/desconnectPlatform']({
        account_id: self.$route.params.account_id,
        platform_id: platform.platform_id,
        params: {
          model_id: self.platform_account.model_id
        },
        callback: res => {
          self.hideLoadingScreen()
          if (res.success) {
            self.refreshPlatformData(platform)
            self.$message.success('Cuenta desconectada con éxito')
            self.platform_account = null
          } else {
            self.$message.error('Error desconectado cuenta')
          }
        }
      })
    },
    findPlatformAccount () {
      console.log('facebook_pages',this.facebook_pages)
      console.log('platform_account',this.platform_account)
      let account = this.facebook_pages.find(p => p.id == this.platform_account.external_id)
      if(account) {
        console.log(account)
        this.confirmConnect(account)
      } else {
        this.$bvModal.msgBoxConfirm(`Inicia sesión con la cuenta de Facebook que tiene permisos de administrar la cuenta que deseas reconectar.`, {
          title: 'No se encontró la página',
          okVariant: 'primary',
          okTitle: 'Reintentar',
          cancelTitle: 'Cancelar'
        })
        .then(value => {
          if (value == true) {
            this.authenticate(this.platform_account.platform)
          } else {
            this.platform_account = null
          }
        })
        .catch(err => {
          this.$message.warning('No se conectó la cuenta.', 'warning')
          this.platform_account = null
        })
      }
    },
    updatePlatformAccount () {
      let self = this
      this.showLoadingScreen()

      this['account/updateAccessToken']({
        ...self.platform_account,
        konverza: 1,
        callback: res => {
          self.hideLoadingScreen()
          self.platform_account = null
          if (res.success) {
            self.$message.success('Cuenta actualizada con éxito')
          } else {
            self.$message.error('Error actualizando cuenta')
          }
        }
      })
    },
    preventConnect () {
      let isKonverza = (new RegExp('^konverza-', 'i')).test(this.getCurrentUser().role_type)
      let isPartner = (new RegExp('^konverza-partner', 'i')).test(this.getCurrentUser().role_type)

      if (isKonverza) {
        // if (!this.account.plan_id) {
        //   this.$bvModal.msgBoxConfirm('Contrata un Plan para poder conectar tu Chatbot a tus redes sociales.', {
        //       title: 'Activa tu cuenta',
        //       okVariant: 'success',
        //       okTitle: 'Suscribir a plan',
        //       cancelTitle: 'Cancelar',
        //       cancelVariant: 'light',
        //       centered: true
        //     })
        //     .then(value => {
        //       if (value == true) {
        //         this.$router.push({name: 'Billing'})
        //       }
        //     })
        //     .catch(() => {})

        //     return true
        // }
      }

      return false
    },
    desconnectOtherAccount () {
      let self = this
      this.showLoadingScreen()

      let platform = this.platforms.find(platform => platform.name == self.platform_account.platform)

      this['account/desconnectPlatform']({
        account_id: self.platform_account.account_id,
        platform_id: platform.platform_id,
        params: {
          model_id: self.platform_account.model_id
        },
        callback: res => {
          self.hideLoadingScreen()
          if (res.success) {
            self.refreshPlatformData(platform)
            self.$message.success('Cuenta desconectada con éxito')
            let facebook_page = self.facebook_pages.find(f => f.id == self.platform_account.page_id)
            if(facebook_page) {
              let index = facebook_page.other_accounts.findIndex(p => p.model_id == self.platform_account.model_id)
              if(index >= 0){
                facebook_page.other_accounts.splice(index, 1)
              }
            }
            self.platform_account = null
          } else {
            self.$message.error('Error desconectado cuenta')
          }
        }
      })
    },
    initFB() {
      if(window.FB) {
        FB.init({
          appId: process.env.VUE_APP_FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true,
          version: 'v12.0'
        });
      }
    },
    launchWhatsAppSignup() {
      let self = this
      FB.login(function (response) {
        console.log(response)
        if (response.authResponse) {
          response.platform = "whatsapp_official"
          self.updatePlatformSubscription(response)
        } else {
          self.$message.error("No se completó el inicio de sesión en Facebook")
        }
      }, {
        scope: 'business_management,whatsapp_business_management',
        extras: {
          feature: 'whatsapp_embedded_signup',
        }
      });
    },
    get_whatsapp_numbers() {
      const self  = this
      const names = ['whatsapp_official','Whatsapp Official']
      const whatsapps_accounts = this.platforms.find(platform => names.includes(platform.name))
      if(!whatsapps_accounts || _.isEmpty(whatsapps_accounts.models)){
        this.accountsLoaded = true;
        return;
      }
      const {waba_id = null} = whatsapps_accounts.models[0]
      if(!waba_id || waba_id < 1) return;

      this['account/phones_status']({
        waba_id,
        callback: async(res) => {
          if(res.error){}
          else{
            const waNumbers = await res.data.map(self.parseWANumber)
            const promises = waNumbers.map(async(wa)=>{
              return await self.addStatsToWANumber(wa,waba_id)
            })
            self.whatsapp_numbers = await Promise.all(promises)
            self.accountsLoaded = true
          }
        }
      })
    },
    get_whatsapp_phone_status(number){
      return this.whatsapp_numbers.find(whatsapp => whatsapp.display_phone_number === number.replace(/ /g,"").replace("+", ""))
    },
    get_whatsapp_phone_stats(phone_number,waba_id){
      return new Promise(resolve=>{
      this['account/phone_stats']({
        waba_id,
        phone_number,
        callback: res => {
          if(res.error){}
          else{
            return resolve(res)
          }
        }
      })})
    },
    async addStatsToWANumber(whatsapp,waba_id){
      const {display_phone_number}= whatsapp
      const {stats} = await this.get_whatsapp_phone_stats(display_phone_number,waba_id)
      return {...whatsapp, stats}
    }
    ,
    parseWANumber(whatsapp){
      whatsapp.display_phone_number = whatsapp.display_phone_number.replace(/ /g,"").replace("+", "")
      return whatsapp
    }
  },
  mounted () {
    this.getAccount()
    this.getPlatforms()
    if(this.getCurrentUser().partner_id) {
      let self = this
      this['partner/get']({
        partner_id: self.getCurrentUser().partner_id,
        callback: async res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    }
    this.initFB()
  },
  watch: {
    auto_reactivation_time () {
      this.auto_reactivation_time_changed = true
    },
    msn_config_modal (val) {
      if(!val) this.platform_account = null
    },
    bm_config_modal (val) {
      if(!val) this.platform_account = null
    },
  },
  components: { ConnectPlatform, MessengerConfig, BmessagingConfig, VoicebotConfig, AlexaConfig, WhatsappConfig }
}
</script>

<style lang="scss" scoped>

  .platforms-container-row {
    width: 100%;
    white-space: nowrap;
    overflow-x: auto;
    padding-bottom: 5px;

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      height: 7px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: rgba(0, 0, 0, .3);
      box-shadow: 0 0 1px rgba(255, 255, 255, .5);
    }

    .platform-square {
      min-width: 130px;
      cursor: pointer;
      &:hover {
        color: blue;
      }
    }
  }
</style>
